module.exports = __webpack_public_path__ + "static/media/shell-icon.30dd0ab2.svg";